(function ($) {
  "use strict";

  /* ---------------- intro animation you already had -------------- */
  $(function () {
    const $banner = $(".banner-area").first();
    if (!$banner.length) return;

    const img = new Image();
    img.src = $banner
      .css("background-image")
      .replace(/url\(["']?(.*?)["']?\)/, "$1");
    img.onload = () => {
      gsap
        .timeline({ defaults: { ease: "power3.out" } })
        .to($banner, { duration: 0.6, scale: 1, opacity: 1 })
        .to(
          ".banner-area__headline",
          { duration: 1.5, y: 0, opacity: 1, stagger: 0.25 },
          "-=.8"
        );
    };
  });

  /* ---------------- helpers -------------------------------------- */
  const $loop = $("#events-loop");
  const $pagination = $("#events-pagination");

  function bindReadMore() {
    $(".event-card-desc .read-more")
      .off("click")
      .on("click", function () {
        $(this)
          .closest(".event-card-desc")
          .find(".hidden-text")
          .toggleClass("show");
      });
  }
  bindReadMore();

  function loadEvents(page = 1, eventType = "") {
    $.post(
      eventsArchive.ajaxUrl,
      {
        action: "linq_load_events",
        nonce: eventsArchive.nonce,
        page: page,
        event_type: eventType,
      },
      (res) => {
        if (!res.success) return; // bail on error

        $loop.html(res.data.html);
        $pagination.html(res.data.pagination);
        bindReadMore();

        history.replaceState(null, "", res.data.url); // keep URL shareable
        document
          .getElementById("archive-events")
          .scrollIntoView({ behavior: "smooth" });
      }
    );
  }
  
  $(document).on("click", ".read-more a", function (e) {
    e.preventDefault();

    const $link = $(this);
    const $wrap = $link.closest(".mobile-event-disc, .col-8");
    const $text = $wrap.find("> .hidden-text"); 

    const opened = $text.hasClass("show");
    $text.toggleClass("show");
    $link.text(opened ? "Read More" : "Read More");
  });

  /* ---------------- click listeners ------------------------------ */
  $(document)
    // category filters
    .on("click", ".cat-button", function (e) {
      e.preventDefault();
      $(".cat-button").removeClass("active");
      $(this).addClass("active");

      const slug = $(this).data("slug") || "";
      loadEvents(1, slug);
    })

    // pagination links (generated HTML will keep handler via delegation)
    .on("click", ".pagination-events a", function (e) {
      e.preventDefault();

      const url = new URL(this.href);
      let page = parseInt(url.searchParams.get("paged") || 0, 10);
      if (!page) {
        // pretty link /page/2/
        const m = url.pathname.match(/\/page\/(\d+)(?:\/|$)/);
        page = m ? parseInt(m[1], 10) : 1;
      }

      const slug = $(".cat-button.active").data("slug") || "";

      loadEvents(page, slug);
    });
})(jQuery);
